import { motion } from "framer-motion";
import React from "react";
import { BodyText } from "../../styles/global";
import {
  TitleText,
  LeftSection,
  RightSection,
  WrapperMainThree,
} from "./Main.styles";

export const MainSectionthree = () => {
  return (
    <>
      <WrapperMainThree>
        <LeftSection>
          <TitleText>
            <div>Virtual debit card</div>
            <BodyText>
              <p className="virtualDebitCard">
                With bonpellz virtual debit card secured by encryption, you can
                make contactless payment in stores and online to purchase items,
                it’s a safe and convenient way to pay online and in store.
              </p>
            </BodyText>
          </TitleText>
        </LeftSection>
        <RightSection>
          <motion.div
            whileInView={{ y: 0, opacity: 1 }}
            initial={{ y: "50%", opacity: 0 }}
            transition={{ duration: 2, stiffness: 1 }}
          >
            <img src="img/Group 8560.jpg" alt="atm card pics" />
          </motion.div>
        </RightSection>
      </WrapperMainThree>
    </>
  );
};
